module.exports = {
  locales: ['en', 'id'],
  defaultLocale: 'en',
  pages: {
    '*': [
      'admin',
      'agent',
      'airline',
      'approval',
      'common',
      'cruise',
      'customer',
      'day',
      'default',
      'error',
      'guest',
      'hotel',
      'navigation',
      'bank-account',
      'upgrade',
      'ticketOrders',
      'document',
      'ticketSales',
      'debt',
      'receipt',
      'product',
      'refund',
      'reschedule',
      'status',
      'report',
      'role',
      'invoice',
      'enum',
      'pathname',
    ],
  },
  localeDetection: false,
  loader: false,
};
